// "Filter by Category" (Audio / Video / Music). Audio and Video match the
// file's media type; Music matches the Music content type (music is stored
// as an audio file with content type Music). Multiple selections combine:
// Audio + Music shows both audio and music items.
export function matchesCategoryFilter(item, selectedCategories) {
  const selected = (Array.isArray(selectedCategories) ? selectedCategories : [])
    .map((value) => String(value || "").toLowerCase())
    .filter(Boolean);
  if (selected.length === 0) return true;

  const mediaType = String(
    item?.mediaTypeCode || item?.type || item?.category || "",
  ).toLowerCase();
  const contentType = String(
    item?.detailState?.contentType || item?.contentType || "",
  ).toLowerCase();
  const typeGroup = String(item?.typeGroup || "").toLowerCase();

  return selected.some((category) => {
    if (category === "music") {
      return contentType === "music" || mediaType === "music";
    }
    return category === mediaType || category === typeGroup;
  });
}
